import {ProteinSpecifier} from 'analyses/aa-sequence-alignment/util/AaSequenceAlignmentConstants';
import {ProteinAlignment} from 'constants/AlignmentConstants';
import {Protein} from 'molbio/aa-sequences/util/AaSequenceConstants';
import * as net from 'util/Net';
import * as TaskRunner from 'util/TaskRunner';
import {Optional} from 'util/Types';

const ProteinAlignmentDAO = {
  get(alignmentId: string): JQueryPromise<ProteinAlignment> {
    // @ts-expect-error: seems like we pass a legacy data format here
    return net.getJSON({
      url: `/1/api/aa-sequence-alignments/${alignmentId}`,
    });
  },

  create({
    proteinName,
    folderId,
    templateProteinIndex,
    proteinSpecifiers,
  }: {
    proteinName: string;
    folderId?: string;
    templateProteinIndex: Optional<number>;
    proteinSpecifiers: Array<ProteinSpecifier>;
  }): JQueryPromise<{protein: Protein; alignment: ProteinAlignment}> {
    return TaskRunner.runTask({
      contentType: 'application/json',
      url: '/1/api/aa-sequence-alignments',
      data: JSON.stringify({proteinName, folderId, proteinSpecifiers, templateProteinIndex}),
      dataType: 'json',
      type: 'POST',
    });
  },

  realignTemplate({
    alignmentId,
    proteinSpecifiers,
  }: {
    alignmentId: string;
    proteinSpecifiers: Array<ProteinSpecifier>;
  }): JQueryPromise<{protein: Protein; alignment: ProteinAlignment}> {
    return TaskRunner.runTask({
      contentType: 'application/json',
      url: `/1/api/aa-sequence-alignments/${alignmentId}/actions/realign-template`,
      data: JSON.stringify({proteinSpecifiers}),
      dataType: 'json',
      type: 'POST',
    });
  },

  realignConsensus({
    alignmentId,
    proteinSpecifiers,
  }: {
    alignmentId: string;
    proteinSpecifiers: Array<ProteinSpecifier>;
  }): JQueryPromise<{protein: Protein; alignment: ProteinAlignment}> {
    return TaskRunner.runTask({
      contentType: 'application/json',
      url: `/1/api/aa-sequence-alignments/${alignmentId}/actions/realign-consensus`,
      data: JSON.stringify({proteinSpecifiers}),
      dataType: 'json',
      type: 'POST',
    });
  },

  delete(alignmentId: string): JQueryPromise<void> {
    return net.delete_({
      url: `/1/api/aa-sequence-alignments/${alignmentId}`,
    });
  },

  rename(alignmentId: string, name: string): JQueryPromise<void> {
    return net.patchJSON({
      url: `/1/api/aa-sequence-alignments/${alignmentId}`,
      data: {name},
    });
  },
};

export default ProteinAlignmentDAO;
